import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContentTableComponent } from './content-table.component'
import { SharedModule } from '../shared/shared.module'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'
import { RouterModule } from '@angular/router';
import { PathLinkTemplateComponent } from './path-link-template/path-link-template.component'



@NgModule({
  declarations: [ContentTableComponent, PathLinkTemplateComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbCollapseModule,
    RouterModule
  ],
  exports: [ContentTableComponent]
})
export class ContentTableModule { }
